import Resizer from "react-image-file-resizer";
import { Attachment } from "../../../../types/common";

type ResizerOutput = string | Blob | File | ProgressEvent<FileReader>;

const IMAGE_MAX_WIDTH = 700;
const IMAGE_MAX_HEIGHT = 600;
const IMAGE_QUALITY = 50;
const DEFAULT_IMAGE_TYPE = "image/jpeg";

const toAttachment = (
  resized: ResizerOutput,
  originalType: string,
): Attachment => {
  if (resized instanceof Blob) {
    return {
      url: URL.createObjectURL(resized),
      type: resized.type || originalType || DEFAULT_IMAGE_TYPE,
    };
  }

  if (typeof resized === "string") {
    return {
      url: resized,
      type: originalType || DEFAULT_IMAGE_TYPE,
    };
  }

  throw new Error("Unsupported image resize output");
};

export const resizeImageFile = async (file: File) =>
  new Promise<Attachment>((resolve) => {
    Resizer.imageFileResizer(
      file,
      IMAGE_MAX_WIDTH,
      IMAGE_MAX_HEIGHT,
      "JPEG",
      IMAGE_QUALITY,
      0,
      (resizedFile) => resolve(toAttachment(resizedFile, file.type)),
      "file",
    );
  });

export const toFileAttachment = (file: File): Attachment => ({
  url: URL.createObjectURL(file),
  type: file.type,
});

export const toAcceptedAttachments = async (
  fileList: FileList | null,
  withVideo: boolean,
): Promise<Attachment[]> => {
  if (fileList === null) return [];

  const files = Array.from(fileList).filter(
    (file) =>
      file.type.startsWith("image/") ||
      (withVideo && file.type.startsWith("video/")),
  );

  return Promise.all(
    files.map((file) =>
      file.type.startsWith("image/")
        ? resizeImageFile(file)
        : toFileAttachment(file),
    ),
  );
};
